import React, { useState } from "react";
import "./home.scss";
import { Grid, Container, Box } from "@mui/material";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import HeaderNew from "../../layout/header/Header-new";

function HomePageWhite() {

    
    const services = [
        {
            title: (
                <>
                   Discover temples
                </>
            ),
            icon: "/assets/home/icons/service-icon-1.webp",
            link: "india-map"
        },
        {
            title: (
                <>
                    Panchang
                </>
            ),
            icon: "/assets/home/icons/punchang.webp",
            link: "coming-soon"
        },
        {
            title: (
                <>
                    Samay AI
                </>
            ),
            icon: "/assets/home/icons/ai.webp",
            link: "coming-soon"
        },
        {
            title: (
                <>
                    Travel booking
                </>
            ),
            icon: "/assets/home/icons/service-icon-4.webp",
            link: "coming-soon"
        },
        {
            title: (
                <>
                    Mythic kids
                </>
            ),
            icon: "/assets/home/icons/kids.webp",
            link: "coming-soon"
        },
        {
            title: (
                <>
                    Blogs
                </>
            ),
            icon: "/assets/home/icons/blogs.webp",
            link: "coming-soon"
        },
        {
            title: (
                <>
                    Certificate
                </>
            ),
            icon: "/assets/home/icons/certificate.webp",
            link: "coming-soon"
        },
        {
            title: (
                <>
                    ⁠Hire a pandit
                </>
            ),
            icon: "/assets/home/icons/pandit.webp",
            link: "coming-soon"
        },
        {
            title: (
                <>
                   ⁠Pilgrimage Financing
                </>
            ),
            icon: "/assets/home/icons/pilgrimage.webp",
            link: "coming-soon"
        },
        ,
        {
            title: (
                <>
                    Horoscope
                </>
            ),
            icon: "/assets/home/icons/horoscope.webp",
            link: "coming-soon"
        },
        {
            title: (
                <>
                    Weather
                </>
            ),
            icon: "/assets/home/icons/wheather.webp",
            link: "coming-soon"
        },
        {
            title: (
                <>
                    Audio guide
                </>
            ),
            icon: "/assets/home/icons/audio.webp",
            link: "coming-soon"
        },
        {
            title: (
                <>
                    ⁠Reunite tag
                </>
            ),
            icon: "/assets/home/icons/tag.webp",
            link: "coming-soon"
        },

    ];

    const actionCards = [
        {
            title: "Locker Booking",
            description: "Explore information, timings, history & more.",
            image: "/assets/home/what-to-do/temple-1.webp",
            link: "locker",
        },
        {
            title: "Navi Stick",
            description: "Create itineraries, book transport, hotels & more.",
            image: "/assets/home/what-to-do/temple-2.webp",
            link: "navi-stick",
        },
        {
            title: "Reunite Band",
            description: "Curated packages for families, groups & individuals",
            image: "/assets/home/what-to-do/temple-3.webp",
            link: "reunite-band",
        },
        {
            title: "VR Darshan",
            description: "Flexible financing options for your pilgrimage",
            image: "/assets/home/what-to-do/temple-4.webp",
            link: "vr-listing",
        },
        {
            title: "Saarthi",
            description: "Secure your belongings at major pilgrimage sites",
            image: "/assets/home/what-to-do/temple-5.webp",
            link: "sarthi-service",
        },
        {
            title: "Yatri Pack",
            description: "360° temple views, mythological videos & walkthroughs",
            image: "/assets/home/what-to-do/temple-6.webp",
            link: "yatri-pack",
        },
        {
            title: "Packages",
            description: "Expert guides for a meaningful journey",
            image: "/assets/home/what-to-do/temple-7.webp",
            link: "coming-soon",
        },
        {
            title: "Souvenir",
            description: "Souvenirs, Yatri Pack, Navi Stick & more",
            image: "/assets/home/what-to-do/temple-8.webp",
            link: "coming-soon",
        },
    ];

    const blogs = [
        {
            title: "Kedarnath Temple",
            description:
                "Divine Trek into the Heart of the Himalayas. This one line captures the unwavering devotion of millions of pilgrims...",
            image: "/assets/home/blogs/blog-img-1.webp",
            link: "#",
        },
        {
            title: "Dwarkadhish Temple",
            description:
                "The Eternal Kingdom of Lord Krishna. A tale of spiritual connection and sacred bridges across the sea...",
            image: "/assets/home/blogs/blog-img-2.webp",
            link: "#",
        },
        {
            title: "Journey to Vaishno Devi",
            description:
                "A Divine Trek into the Heart of the Himalayas. This one line captures the unwavering devotion of millions of pilgrims...",
            image: "/assets/home/blogs/blog-img-3.webp",
            link: "#",
        },
        {
            title: "Gangotri Temple",
            description:
                "In the Lap of the Ganges and the Himalayas. Explore one of the most famous Hindu temples dedicated to Lord Shiva...",
            image: "/assets/home/blogs/blog-img-4.webp",
            link: "#",
        },
    ];

    return (
        <>

            <style>{`
        .header {
          display: none;
        }

        .newsLetter {
          display: none;
        }

        .copyright {
          display: none;
        }

        .footer {
          display: none;
        }
      `}</style>
            <div className="homeHero">
                <div className="homeHeroOverlay" />

                {/* ================= HEADER ================= */}
             
                <HeaderNew />

                {/* ================= HERO ================= */}
                <div className="heroContainer">
                    <Container maxWidth="lg" >
                        <Grid container>
                            <Grid size={{ xs: 12, lg: 8 }}>
                                <div className="heroContent">
                                    <h1>
                                        Begin Your
                                        <br />
                                        Divine Journey
                                    </h1>

                                    <p>
                                        Discover sacred places, plan your trip,
                                        access trusted
                                        <br className="desktopBreak" />
                                        services &amp; experience the spiritual
                                        essence of India.
                                    </p>

                                    {/* SEARCH */}
                                    <form
                                        className="heroSearch"
                                        onSubmit={(e) => e.preventDefault()}
                                    >
                                        <div className="searchField">
                                            <input
                                                type="text"
                                                placeholder="Search a temple"
                                            />
                                        </div>

                                        <button type="submit">
                                            EXPLORE
                                        </button>
                                    </form>
                                </div>
                            </Grid>
                        </Grid>
                    </Container>
                </div>

                {/* ================= SERVICES ================= */}
                <div className="servicesSection">
    <Container maxWidth="lg">
        <div className="servicesSliderWrap">

            <Swiper
                modules={[Autoplay, Navigation]}
                className="servicesSwiper"
                spaceBetween={14}
                slidesPerView={8}
                loop={true}
                navigation={{
                    nextEl: ".servicesNext",
                    prevEl: ".servicesPrev",
                }}
                breakpoints={{
                    0: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                    },

                    480: {
                        slidesPerView: 2.5,
                        spaceBetween: 10,
                    },

                    576: {
                        slidesPerView: 3,
                        spaceBetween: 12,
                    },

                    768: {
                        slidesPerView: 4,
                        spaceBetween: 14,
                    },

                    992: {
                        slidesPerView: 6,
                        spaceBetween: 14,
                    },

                    1200: {
                        slidesPerView: 8,
                        spaceBetween: 14,
                    },

                    1600: {
                        slidesPerView: 8,
                        spaceBetween: 18,
                    },
                }}
            >
                {services.map((service, index) => (
                    <SwiperSlide key={index}>
                        <a
                            href={service.link}
                            className="serviceCard"
                        >
                            <div className="serviceIcon">
                                {service.icon && (
                                    <img
                                        src={service.icon}
                                        alt=""
                                    />
                                )}
                            </div>

                            <div className="serviceTitle">
                                {service.title}
                            </div>
                        </a>
                    </SwiperSlide>
                ))}

                <button
                    className="servicesPrev"
                    aria-label="Previous"
                >
                    <span>‹</span>
                </button>

                <button
                    className="servicesNext"
                    aria-label="Next"
                >
                    <span>›</span>
                </button>
            </Swiper>

        </div>
    </Container>
</div>
            </div>

            <section className="bodyBg whiteBg">
                <Container maxWidth="lg">
                    <Grid container spacing={4}>
                        <Grid
                            size={{
                                xl: 12,
                                lg: 12,
                                md: 12,
                                sm: 12,
                                xs: 12,
                            }}
                        >
                            <div className="whatToDoSection pb-0">
                                {/* ================= HEADING ================= */}
                                <div className="commonSectionHeading">
                                    <h2>What would you like to do?</h2>
                                </div>

                                {/* ================= CARDS ================= */}
                                <Container maxWidth="lg">

                                    {/* Desktop */}
                                    <Box sx={{ display: { xs: "none", md: "block" } }}>
                                        <Grid container spacing={3}>
                                            {actionCards.map((card, index) => (
                                                <Grid
                                                    key={index}
                                                    size={{
                                                        xl: 3,
                                                        lg: 3,
                                                        md: 6,
                                                    }}
                                                >
                                                    <a href={card.link} className="actionCard">
                                                        <img src={card.image} alt={card.title} />

                                                        <div className="actionOverlay"></div>

                                                        <div className="actionContent">
                                                            <h3>{card.title}</h3>
                                                            <p>{card.description}</p>
                                                        </div>

                                                        <span className="actionArrow">→</span>
                                                    </a>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </Box>

                                    {/* Mobile Slider */}
                                    <Box sx={{ display: { xs: "block", md: "none" } }}>
                                        <Swiper
                                            modules={[Pagination, Autoplay]}
                                            spaceBetween={15}
                                            slidesPerView={1.15}
                                            pagination={{
                                                clickable: true,
                                            }}
                                            // autoplay={{
                                            //     delay: 3000,
                                            //     disableOnInteraction: false,
                                            // }}
                                            loop={actionCards.length > 3}
                                            breakpoints={{
                                                768: {
                                                    slidesPerView: 2.5,
                                                    spaceBetween: 15,
                                                },
                                            }}
                                        >
                                            {actionCards.map((card, index) => (
                                                <SwiperSlide key={index}>
                                                    <a href={card.link} className="actionCard">
                                                        <img src={card.image} alt={card.title} />

                                                        <div className="actionOverlay"></div>

                                                        <div className="actionContent">
                                                            <h3>{card.title}</h3>
                                                            <p>{card.description}</p>
                                                        </div>

                                                        <span className="actionArrow">→</span>
                                                    </a>
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>
                                    </Box>

                                </Container>

                                {/* ================= APP BANNER ================= */}
                                <div className="appBanner">
                                    <Container maxWidth="lg">
                                        <Grid container className="appBannerGrid">
                                            {/* LEFT CONTENT */}
                                            <Grid
                                                size={{
                                                    xl: 5,
                                                    lg: 5,
                                                    md: 5,
                                                    sm: 12,
                                                    xs: 12,
                                                }}
                                            >
                                                <div className="appBannerContent">
                                                    <h2>
                                                        Experience the Divine with
                                                        <br />
                                                        MandirWiki App
                                                    </h2>

                                                    <p>
                                                        Unlock exclusive features like VR Darshan, AR Navigation, Audio
                                                        Guide and more only on the app.
                                                    </p>

                                                    <span className="downloadText">Download the App</span>

                                                    <div className="appStoreButtons">
                                                        <a href="#" className="storeButton">
                                                            <img
                                                                src="/assets/home/icons/google-play.png"
                                                                alt="Google Play"
                                                                className="img-fluid"
                                                            />
                                                        </a>

                                                        <a href="#" className="storeButton">
                                                            <img
                                                                src="/assets/home/icons/app-store.png"
                                                                alt="App Store"
                                                                className="img-fluid"
                                                            />
                                                        </a>
                                                    </div>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Container>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </Container>

                {/* devotees section start */}

                <section className="pb-0">
                    <Container maxWidth="lg">
                        <div className="statsSection">
                            <Grid container className="statsGrid">
                                {/* 7 Lakh+ */}
                                <Grid size={{ xl: 2.4, lg: 2.4, md: 4, sm: 6, xs: 6 }}>
                                    <div className="statsCard">
                                        <img src="/assets/home/icons/devotees-icon.png" alt="Devotees Served" />
                                        <div>
                                            <h3>7 Lakh+</h3>
                                            <p>Devotees Served</p>
                                        </div>
                                    </div>
                                </Grid>

                                <Grid size={{ xl: 3, lg: 3, md: 4, sm: 6, xs: 6 }}>
                                    <div className="statsCard">
                                        <img src="/assets/home/icons/onsite-booking-icon.png" alt="Devotees Served" />
                                        <div>
                                            <h3>App, Web, WhatsApp</h3>
                                            <p>& Onsite Booking</p>
                                        </div>
                                    </div>
                                </Grid>

                                <Grid size={{ xl: 1.8, lg: 1.8, md: 4, sm: 6, xs: 6 }}>
                                    <div className="statsCard">
                                        <img src="/assets/home/icons/destination-icon.png" alt="Devotees Served" />
                                        <div>
                                            <h3>100+</h3>
                                            <p>Destinations</p>
                                        </div>
                                    </div>
                                </Grid>

                                <Grid size={{ xl: 2.4, lg: 2.4, md: 4, sm: 6, xs: 6 }}>
                                    <div className="statsCard">
                                        <img src="/assets/home/icons/smart-watch-icon.png" alt="Devotees Served" />
                                        <div>
                                            <h3>Smart Services at</h3>
                                            <p>Major Pilgrimage Sites</p>
                                        </div>
                                    </div>
                                </Grid>

                                <Grid size={{ xl: 2.4, lg: 2.4, md: 4, sm: 6, xs: 6 }}>
                                    <div className="statsCard">
                                        <img src="/assets/home/icons/startup-icon.png" alt="Devotees Served" />
                                        <div>
                                            <h3>Startup India</h3>
                                            <p>Recognised</p>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </Container>
                </section>

                {/* devotees section end */}

               <section className="latestBlogs bg-white pb-0">
    <Container maxWidth="lg">
        <div className="commonSectionHeading">
            <h2>Explore Latest Blogs</h2>
        </div>

        <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            className="latestBlogsSwiper"
            spaceBetween={30}
            slidesPerView={4}
            loop={true}
            navigation
            pagination={{
                clickable: true,
            }}
            autoplay={{
                delay: 3000,
                disableOnInteraction: false,
            }}
            breakpoints={{
                0: {
                    slidesPerView: 1,
                    spaceBetween: 15,
                },
                576: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
            }}
        >
            {blogs.map((blog, index) => (
                <SwiperSlide key={index}>
                    <article className="blogCard">
                        <div className="blogImage">
                            <img
                                src={blog.image}
                                alt={blog.title}
                            />
                        </div>

                        <div className="blogContent">
                            <h3>{blog.title}</h3>

                            <p>{blog.description}</p>

                            <div className="blogFooter">
                                <a
                                    href={blog.link}
                                    className="readMoreBtn"
                                >
                                    Read Full Article
                                </a>
                            </div>
                        </div>
                    </article>
                </SwiperSlide>
            ))}
        </Swiper>
    </Container>
</section>

            </section>

            <section className="mysteriesSection pt-0">
                <Container maxWidth="lg">
                    <div className="commonSectionHeading">
                        <h2>Mysteries and Marvels of Temples</h2>
                    </div>

                    <Grid container spacing={{ xs: 4, md: 6, lg: 8 }} alignItems="center" className="mysteriesContent">
                        {/* IMAGE */}
                        <Grid size={{ xs: 12, lg: 6 }}>
                            <div className="mysteriesImage">
                                <img src="/assets/stories-img.svg" alt="Kedarnath Temple" />
                            </div>
                        </Grid>

                        {/* CONTENT */}
                        <Grid size={{ xs: 12, lg: 6 }}>
                            <div className="mysteriesText">
                                <h3>KEDARNATH</h3>

                                <p>
                                    It is believed to be one of the 12 Jyotirlingas, and its history and construction
                                    remain shrouded in some mystery, with legends connecting it to the Pandavas.
                                </p>

                                <p>
                                    The temple's unique architecture and its survival during the 2013 floods add to its
                                    mystique.
                                </p>
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </section>

            
        </>
    );
}

export default HomePageWhite;
